import CompanyForm from 'components/Forms/CompanyForm';
import { useTranslation } from 'context/translation';
const AddCompany = () => {
  const { t }: any = useTranslation();

  return <CompanyForm title={t('add_new_company') || 'Add New Company'} />;
};

export default AddCompany;
